var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;

  return "<div class=\"modal in tableSelectListModal\">\n    <div class=\"modal-dialog\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <span class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"></span>\n          <h4 class=\"modal-title \">"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.comp.select.table.modal.title",{"name":"i18n","hash":{},"data":data}))
    + "("
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.comp.select.table.modal.current",{"name":"i18n","hash":{},"data":data}))
    + " "
    + alias2(container.lambda((depth0 != null ? depth0.currentTableName : depth0), depth0))
    + ")</h4>\n          <!--button type=\"button\" data-dismiss=\"modal\">直接点单</button-->\n        </div>\n        <div class=\"listContainer\">\n        </div>\n      </div>\n    </div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/pos/comp/TableSelectModal.handlebars
// module id = 544
// module chunks = 0